import { clsx } from 'clsx';
import { FC, MouseEventHandler, ReactNode } from 'react';
import { Shade } from '../Shade/Shade';
import classes from './ToggleButtons.module.scss';

type Props = Prettify<{
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isSelected: boolean;
  className?: string;
  fullWidth?: boolean;
  variant: 'rounded' | 'squared';
}>;

const ToggleButtonItem: FC<Props> = ({
  children,
  onClick,
  disabled = false,
  className,
  isSelected,
  fullWidth = false,
  variant,
}: Readonly<Props>) => {
  return (
    <button
      onClick={onClick}
      className={clsx('shade_container', 'toggleButton', classes.root, `toggleButton--${variant}`, className, {
        [classes.isSelected]: isSelected,
        [classes.disabled]: disabled,
        [classes.fullWidth]: fullWidth,
      })}
      disabled={disabled}
    >
      <Shade />
      {children}
    </button>
  );
};

export default ToggleButtonItem;
